$(function() {

    $('.show-more').click(function() {

        let currText = $(this).text();
        let nextText = $(this).data('text');
        let target = $(this).data('target');
        let speed = $(this).data('slide') || 600;

        if ($(document).find(target).length == 0) {
            return;
        }

        if ($(document).find(target).css('display') == 'none') {
            $(document).find(target).slideDown(speed);
        } else {
            $(document).find(target).slideUp(speed);
        }

        if (nextText) {
            $(this).text(nextText);
            $(this).attr('data-text', currText);
        }
    });

});